function locationReducer(currentState = [], action){
    switch (action.type) {
        case 'LOCATION_INIT':
            return action.payload;
        default:
            break;
    }
    return currentState;
}

export default locationReducer;